<template>
  <v-container fluid class="pa-0">
    <v-row no-gutters>
      <v-col cols="12">
        <v-btn
          class="custom-fab"
          color="teal darken-3"
          dark
          absolute
          bottom
          right
          fab
          to="/report"
        >
          <v-icon>mdi-bell</v-icon>
        </v-btn>
        <notifications
          group="notif-group-map"
          position="bottom right"
          style="max-height:400px;bottom:126px"
          classes="vue-notification-custom"
        />

        <gmap-map
          class="gmap"
          ref="gmap"
          :options="mapOptions"
          :center="center"
          :zoom="10"
          :scrollwheel="false"
          map-type-id="hybrid"
          :style="
            $vuetify.breakpoint.name === 'xs'
              ? 'height: calc(100vh - 56px);'
              : 'height: calc(100vh - 64px);'
          "
        >
          <v-card class="card-map" min-width="300" max-width="300">
            <v-card-title class="body-1 pb-0">
              Trending
            </v-card-title>
            <v-card-text>
              <v-list dense>
                <v-list-item-group color="light-green">
                  <v-skeleton-loader
                    type="text"
                    transition="fade-transition"
                    :class="{ 'py-3': loadingTrendings }"
                    :loading="loadingTrendings"
                    v-for="(trending, index) in loadingTrendings
                      ? 3
                      : trendings"
                    :key="`trending-${index}`"
                  >
                    <v-list-item to="/dashboard">
                      <v-list-item-content>
                        <v-badge
                          color="light-green"
                          :content="trending.total"
                          inline
                          bordered
                          value="1"
                        >
                          <v-list-item-title
                            class="body-2 text--secondary text-capitalize"
                          >
                            {{ trending.trendingsKeyword }}
                          </v-list-item-title>
                        </v-badge>
                      </v-list-item-content>
                    </v-list-item>
                  </v-skeleton-loader>
                </v-list-item-group>
              </v-list>
              <span
                class="text-center text--secondary"
                v-show="!loadingTrendings && trendings.length < 1"
              >
                Belum ada data
              </span>
              <!-- <p class="text-body-1">Filter Marker</p>
              <v-select
                :items="[
                  { text: 'Semua', value: 'all' },
                  { text: 'Unit', value: 'unit' },
                  { text: 'Satgas', value: 'satgas' },
                  { text: 'Event', value: 'event' }
                ]"
                class="d-block"
                v-model="selectedMarker"
                outlined
                label="Filter"
                dense
              /> -->
            </v-card-text>
          </v-card>
          <gmap-marker
            v-for="(item, index) in showedMarkers"
            ref="markers"
            :key="index"
            :animation="item.animation"
            :position="item.position"
            :icon="item.icon"
            @click="toggleInfoWindow(item, index)"
          >
          </gmap-marker>
          <gmap-circle
            v-for="(item, index) in markerEvents"
            ref="eventMarker"
            :key="`event-${index}`"
            :center="item.position"
            :radius="
              currentMapZoomEvent < 1
                ? item.radius
                : item.radius * currentMapZoomEvent
            "
            :options="{
              fillColor: 'white',
              fillOpacity: 0.4,
              strokeColor: 'white',
              strokeOpacity: 0.1,
              strokeWeight: 1
            }"
            @click="toggleInfoWindow(item, index, markerEvents)"
          />
          <gmap-info-window
            :options="infoOptions"
            :position="infoWindowPos"
            :opened="infoWinOpen"
            @closeclick="infoWinOpen = false"
          >
            <div v-html="infoContent"></div>
          </gmap-info-window>
        </gmap-map>
      </v-col>
    </v-row>
    <v-footer padless absolute color="rgba(0,0,0,.6)">
      <v-container fluid class="pa-0">
        <v-row no-gutters align="center">
          <v-col
            cols="3"
            class="clock bottom-text text-center py-2 text-uppercase d-none d-sm-block"
          >
            {{ clock | dateclock }}
          </v-col>
          <v-col class="bottom-text py-2" cols="12" sm="9">
            <marquee-text :repeat="1" :duration="20" :key="message.id">
              {{ message.content }}
            </marquee-text>
          </v-col>
        </v-row>
      </v-container>
    </v-footer>
  </v-container>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/messaging';

import monitoring from '@/mixins/monitoring';
import map from '@/mixins/map';
import MarqueeText from 'vue-marquee-text-component';

import moment from 'moment';
moment.locale('id');

export default {
  mixins: [map, monitoring],
  components: {
    MarqueeText
  },
  data() {
    return {
      currentPage: 1,
      clock: null,
      messages: [{ id: 0, content: '' }],
      interval: null,
      markerEvents: [],
      currentMapZoomEvent: 10,
      selectedMarker: 'all',
      mapOptions: {
        zoomControl: true,
        zoomControlOptions: {
          // eslint-disable-next-line no-undef
          // position: google.maps.ControlPosition.TOP_RIGHT
        },
        mapTypeControl: true,
        mapTypeControlOptions: {
          // eslint-disable-next-line no-undef
          // style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
          // eslint-disable-next-line no-undef
          // position: google.maps.ControlPosition.LEFT_TOP,
          mapTypeIds: ['roadmap', 'hybrid']
        },
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        disableDefaultUi: false
      }
    };
  },
  computed: {
    message() {
      return this.messages[0];
    },
    showedMarkers() {
      if (this.selectedMarker === 'unit') {
        return this.markers.filter((item) => item.type === 'unit');
      } else if (this.selectedMarker === 'satgas') {
        return this.markers.filter((item) => item.type === 'user');
      } else if (this.selectedMarker === 'event') {
        return this.markers.filter((item) => item.type === 'event');
      }
      return this.markers;
    }
  },
  created() {
    // Handle incoming messages.
    // if (process.browser) {
    //   if ('Notification' in window && 'serviceWorker' in navigator) {
    //     navigator.serviceWorker.addEventListener('message', (event) => {
    //       console.log(event);
    //     });
    //   }
    // }
    // Handle incoming messages. Called when:
    // - a message is received while the app has focus
    // - the user clicks on an app notification created by a service worker
    //   `messaging.setBackgroundMessageHandler` handler.
    if (firebase.messaging.isSupported()) {
      const messaging = firebase.messaging();

      messaging.onMessage((payload) => {
        // eslint-disable-next-line no-console
        // console.log('Message received. ', payload.data);
        const data = JSON.parse(payload.data.payload);
        const index = this.markers.findIndex(
          (el) => el.content.accountId === data.account_id
        );
        if (index !== -1) {
          this.markers[index].animation = 1;
          setTimeout(() => {
            this.markers[index].animation = 0;
          }, 5000);
        }
        this.pushMessage(payload);
        if (this.messages[0].id === 0) {
          clearInterval(this.interval);
          this.messages.splice(0, 1);
          this.interval = setInterval(() => this.showMessage(), 20000);
        }
        this.showNotif(payload);
      });
    }

    this.setClock();
    this.getUsersHandler();
    // this.getUnitsHandler();
    // this.getEventsHandler();
    this.getLahanHandler();
    this.getTrendings();
    setInterval(() => this.getTrendings(), 1800000);
  },
  methods: {
    showMessage() {
      if (this.messages.length > 1) {
        this.messages.splice(0, 1);
      } else {
        this.messages = [{ id: 0, content: '' }];
        clearInterval(this.interval);
      }
      return true;
    },
    setClock() {
      setInterval(() => {
        const now = moment();
        this.clock = now._d;
      }, 1000);
    },
    pushMessage(payload) {
      const data = JSON.parse(payload.data.payload);
      const message = {
        id: data.report_id,
        content: `${data.account_name}, ${data.unit_name} Mengirimkan laporan dari ${data.report_subdistrict_name}, ${data.report_location} : ${payload.data.body}`
      };
      this.messages.push(message);
    },
    showNotif(payload) {
      const data = JSON.parse(payload.data.payload);
      this.$notify({
        group: 'notif-group-map',
        title: data.account_name,
        text: `Mengirimkan laporan dari ${data.report_subdistrict_name}, ${data.report_location} : ${payload.data.body}`,
        type: 'success'
      });
    },
    async getUsersHandler() {
      const users = await this.getUsers();
      this.$refs.gmap.$mapPromise.then((map) => {
        users.forEach((p) => {
          let icon = require('@/assets/icons/marker-babinsa.svg');
          if (p.unitType === 'desa') {
            icon = require('@/assets/icons/marker-satgas.svg');
          }
          this.markers.push({
            type: 'user',
            content: p,
            animation: 0,
            position: {
              lat: parseFloat(p.accountLastLatitude),
              lng: parseFloat(p.accountLastLongitude)
            },
            icon: {
              url: icon,
              // eslint-disable-next-line no-undef
              scaledSize: new google.maps.Size(25, 30),
              // eslint-disable-next-line no-undef
              origin: new google.maps.Point(0, 0),
              // eslint-disable-next-line no-undef
              anchor: new google.maps.Point(0, 0)
            }
          });
        });
        map.addListener('zoom_changed', function() {
          if (map.zoom >= 5 && map.zoom < 10) {
            this.radius = 10000;
          } else if (map.zoom >= 10 && map.zoom < 12) {
            this.radius = 5000;
          } else if (map.zoom >= 12 && map.zoom < 14) {
            this.radius = 2500;
          } else if (map.zoom >= 14 && map.zoom < 16) {
            this.radius = 1250;
          } else if (map.zoom >= 16 && map.zoom < 18) {
            this.radius = 625;
          } else if (map.zoom >= 18 && map.zoom < 20) {
            this.radius = 322.5;
          }
        });
      });
    },
    async getLahanHandler() {
      const { data, meta } = await this.getLahan(this.currentPage);
      const lastPage = meta.lastPage;
      if (this.currentPage < lastPage) {
        this.currentPage += 1;
        this.getLahanHandler();
      }
      this.$refs.gmap.$mapPromise.then((map) => {
        data.forEach((p) => {
          let icon = require('@/assets/icons/solusi-organik-indonesia.png');
          if (p.unitAttributes && p.unitAttributes['entitas']) {
            if (p.unitAttributes['entitas'] === 'Solusi Organik Indonesia') {
              icon = require('@/assets/icons/solusi-organik-indonesia.png');
            } else if (
              p.unitAttributes['entitas'] === 'Setiabudi Farming Solution'
            ) {
              icon = require('@/assets/icons/setiabudi-farming-solution.png');
            } else if (p.unitAttributes['entitas'] === 'Sinergi Daur Ulang') {
              icon = require('@/assets/icons/sinergi-daur-ulang.png');
            } else if (
              p.unitAttributes['entitas'] === 'Setiabudi Socionomics Company'
            ) {
              icon = require('@/assets/icons/setiabudi-socionomics-company.png');
            }
          }
          this.markers.push({
            type: 'lahan',
            content: p,
            animation: 0,
            position: {
              lat: parseFloat(p.latitude),
              lng: parseFloat(p.longitude)
            },
            icon: {
              url: icon,
              // eslint-disable-next-line no-undef
              scaledSize: new google.maps.Size(25, 30),
              // eslint-disable-next-line no-undef
              origin: new google.maps.Point(0, 0),
              // eslint-disable-next-line no-undef
              anchor: new google.maps.Point(0, 0)
            }
          });
        });
        map.addListener('zoom_changed', function() {
          if (map.zoom >= 5 && map.zoom < 10) {
            this.radius = 10000;
          } else if (map.zoom >= 10 && map.zoom < 12) {
            this.radius = 5000;
          } else if (map.zoom >= 12 && map.zoom < 14) {
            this.radius = 2500;
          } else if (map.zoom >= 14 && map.zoom < 16) {
            this.radius = 1250;
          } else if (map.zoom >= 16 && map.zoom < 18) {
            this.radius = 625;
          } else if (map.zoom >= 18 && map.zoom < 20) {
            this.radius = 322.5;
          }
        });
      });
    },
    async getEventsAreaHandler() {
      const events = await this.getEvents();
      const app = this;

      const getRadius = (totalParticipant) => {
        let divider = 50;
        const total = parseInt(totalParticipant);
        if (total > 1000) {
          divider = 100;
        }
        if (total > 10000) {
          divider = 1000;
        }
        if (total > 20000) {
          divider = 2000;
        }
        if (total > 50000) {
          divider = 5000;
        }
        if (total > 100000) {
          divider = 10000;
        }
        if (total > 200000) {
          divider = 20000;
        }
        return (total / divider) * 10;
      };

      this.$refs.gmap.$mapPromise.then((map) => {
        events.forEach((p) => {
          this.markerEvents.push({
            type: 'event',
            content: p,
            animation: 0,
            radius: getRadius(p.eventParticipant),
            position: {
              lat: parseFloat(p.eventLatitude),
              lng: parseFloat(p.eventLongitude)
            }
          });
        });
        map.addListener('zoom_changed', function() {
          app.currentMapZoomEvent = map.zoom;
        });
      });
    },
    async getEventsHandler() {
      const events = await this.getEvents();
      this.$refs.gmap.$mapPromise.then((map) => {
        events.forEach((p) => {
          let icon = require('@/assets/icons/people.png');
          this.markers.push({
            type: 'event',
            content: p,
            position: {
              lat: parseFloat(p.eventLatitude),
              lng: parseFloat(p.eventLongitude)
            },
            icon: {
              url: icon,
              // eslint-disable-next-line no-undef
              scaledSize: new google.maps.Size(50, 50),
              // eslint-disable-next-line no-undef
              origin: new google.maps.Point(0, 0),
              // eslint-disable-next-line no-undef
              anchor: new google.maps.Point(0, 0)
            }
          });
        });
        map.addListener('zoom_changed', function() {
          if (map.zoom >= 5 && map.zoom < 10) {
            this.radius = 10000;
          } else if (map.zoom >= 10 && map.zoom < 12) {
            this.radius = 5000;
          } else if (map.zoom >= 12 && map.zoom < 14) {
            this.radius = 2500;
          } else if (map.zoom >= 14 && map.zoom < 16) {
            this.radius = 1250;
          } else if (map.zoom >= 16 && map.zoom < 18) {
            this.radius = 625;
          } else if (map.zoom >= 18 && map.zoom < 20) {
            this.radius = 322.5;
          }
        });
      });
    },
    async getUnitsHandler() {
      const units = await this.getUnits();
      this.$refs.gmap.$mapPromise.then((map) => {
        units.forEach((p) => {
          let icon = require('@/assets/icons/marker-koramil.svg');
          if (p.unitType === 'desa') {
            icon = require('@/assets/icons/marker-desa.svg');
          }
          this.markers.push({
            type: 'unit',
            content: p,
            position: {
              lat: parseFloat(p.unitLatitude),
              lng: parseFloat(p.unitLongitude)
            },
            icon: {
              url: icon,
              // eslint-disable-next-line no-undef
              scaledSize: new google.maps.Size(25, 25),
              // eslint-disable-next-line no-undef
              origin: new google.maps.Point(0, 0),
              // eslint-disable-next-line no-undef
              anchor: new google.maps.Point(0, 0)
            }
          });
        });
        map.addListener('zoom_changed', function() {
          if (map.zoom >= 5 && map.zoom < 10) {
            this.radius = 10000;
          } else if (map.zoom >= 10 && map.zoom < 12) {
            this.radius = 5000;
          } else if (map.zoom >= 12 && map.zoom < 14) {
            this.radius = 2500;
          } else if (map.zoom >= 14 && map.zoom < 16) {
            this.radius = 1250;
          } else if (map.zoom >= 16 && map.zoom < 18) {
            this.radius = 625;
          } else if (map.zoom >= 18 && map.zoom < 20) {
            this.radius = 322.5;
          }
        });
      });
    },
    getInfoWindowContent(marker) {
      if (marker.type == 'user') {
        return `
          <div id="iw-container" class="iw-user">
            <div class="iw-content">
              <img class="profile" src="${marker.content.accountAvatar}" height="100" width="100">
              <div class="iw-subTitle">
                <a href="/user/detail/${marker.content.accountId}/laporan" target="_blank">
                  ${marker.content.accountName}
                </a>
              </div>
              <p>
                Telepon. ${marker.content.accountMobilephone}
                <br>
                NRP/NIK. ${marker.content.accountCode}
                <br>
                Unit ${marker.content.unitName}
              </p>
              <p>
                <a href="/user/detail/${marker.content.accountId}/laporan" target="_blank" style="color:blue">
                  Lihat detail...
                </a>
              </p>
            </div>
          </div>
        `;
      } else if (marker.type == 'event') {
        return `
          <div id="iw-container" class="iw-event">
            ${
              marker.content.eventAttachment &&
              marker.content.eventAttachment[0]
                ? `
             <div class="iw-image">
              <div class="v-image v-responsive theme--light" style="max-height: 100px; width: 100%;">
                <div class="v-responsive__sizer" style="padding-bottom: 100%;"></div>
                <div class="v-image__image v-image__image--cover" style="background-image: url(&quot;${marker.content.eventAttachment[0].url.compressed}&quot;); background-position: center center;"></div>
                <div class="v-responsive__content" style="width: 300px;"></div>
              </div>
            </div>
            `
                : ``
            }
            <div class="iw-content">
              <p>
                <b> ${marker.content.eventName} </b>
              </p>
              <p>
                <i> ${marker.content.eventDate} </i>
              </p>
              <p>
                ${marker.content.eventContent.substring(0, 100) + '...'}
              </p>
              <p>
                <a href="/event/${
                  marker.content.eventId
                }" target="_blank" style="color:blue">
                  Lihat selengkapnya...
                </a>
              </p>
            </div>
          </div>
        `;
      } else if (marker.type == 'lahan') {
        return `
          <div id="iw-container" class="iw-event">
            <div class="iw-content">
              <p>
                <b> ${marker.content.name} </b>
              </p>
              <p>
                ${marker.content.address}
              </p>
              <div style="margin: 10px 0px;text-transform: capitalize;">
                <p><b>Detail</b></p>
                ${
                  Object.keys(marker.content.unitAttributes).length > 0
                    ? Object.entries(marker.content.unitAttributes)
                        .map(([key, value]) => {
                          return `<p><b>${key}</b>: ${value}</p>`;
                        })
                        .join('')
                    : '<p>Tidak ada data</p>'
                }
                </div>
            </div>
          </div>
        `;
      } else {
        if (marker.content.unitType === 'desa') {
          return `
          <div id="iw-container" class="iw-unit">
            <div class="iw-content">
              <div class="iw-subTitle">
                <a href="/wilayah/${marker.content.unitId}" target="_blank">
                  Wilayah ${marker.content.unitName}
                </a>
              </div>
              <div style="display: grid;grid-template-columns: 1fr 1fr;justify-content: space-between;margin: 4px 0px;">
                <div>
                  <p><b>Jumlah Penduduk</b></p>
                  <p>${marker.content.unitJumlahPenduduk}</p>
                </div>
                <div>
                  <p><b>Kondisi Geografis</b></p>
                  <p>${marker.content.unitKondisiGeografis}</p>
                </div>
              </div>
              <div style="display: grid;grid-template-columns: 1fr 1fr;justify-content: space-between;margin: 4px 0px;">
                <div>
                  <p><b>Kerawanan</b></p>
                  <p>${marker.content.unitKerawanan}</p>
                </div>
                <div>
                  <p><b>Konstelasi Politik</b></p>
                  <p>${marker.content.unitKonstelasiPolitik}</p>
                </div>
              </div>
              <div style="margin: 4px 0px;">
                <p><b>Bencana alam</b></p>
                <p>${marker.content.unitBencanaAlam}</p>
              </div>
              <div style="margin: 12px 0px;">
                <p><b>Tokoh Daerah</b></p>
                ${
                  marker.content.unitTokohDaerah.length > 0
                    ? marker.content.unitTokohDaerah.map((item) => {
                        return `
                        <div style="display: grid;gap: 10px;grid-template-columns: 1fr 1fr 1fr;justify-content: space-between;margin: 4px 0px;">
                          <div>
                            <p><b>Nama</b></p>
                            <p>${item.nama}</p>
                          </div>
                          <div>
                            <p><b>Jabatan</b></p>
                            <p>${item.jabatan}</p>
                          </div>
                          <div>
                            <p><b>No. HP</b></p>
                            <p>${item.noHandphone}</p>
                          </div>
                          </div>
                        `;
                      })
                    : '<p>Tidak ada data</p>'
                }
              </div>
              <div style="margin: 12px 0px;">
                <p><b>Tokoh Masyarakat</b></p>
                ${
                  marker.content.unitTokohMasyarakat.length > 0
                    ? marker.content.unitTokohMasyarakat.map((item) => {
                        return `
                        <div style="display: grid;gap: 10px;grid-template-columns: 1fr 1fr 1fr;justify-content: space-between;margin: 4px 0px;">
                          <div>
                            <p><b>Nama</b></p>
                            <p>${item.nama}</p>
                          </div>
                          <div>
                            <p><b>Jabatan</b></p>
                            <p>${item.jabatan}</p>
                          </div>
                          <div>
                            <p><b>No. HP</b></p>
                            <p>${item.noHandphone}</p>
                          </div>
                          </div>
                        `;
                      })
                    : '<p>Tidak ada data</p>'
                }
              </div>
              <div style="margin: 12px 0px;">
                <p><b>Tokoh Masyarakat</b></p>
                ${
                  marker.content.unitTokohAgama.length > 0
                    ? marker.content.unitTokohAgama.map((item) => {
                        return `
                        <div style="display: grid;gap: 10px;grid-template-columns: 1fr 1fr 1fr;justify-content: space-between;margin: 4px 0px;">
                          <div>
                            <p><b>Nama</b></p>
                            <p>${item.nama}</p>
                          </div>
                          <div>
                            <p><b>Jabatan</b></p>
                            <p>${item.jabatan}</p>
                          </div>
                          <div>
                            <p><b>No. HP</b></p>
                            <p>${item.noHandphone}</p>
                          </div>
                          </div>
                        `;
                      })
                    : '<p>Tidak ada data</p>'
                }
              </div>
              <p>
                <a href="/wilayah/${
                  marker.content.unitId
                }" target="_blank" style="color:blue">
                  Lihat detail...
                </a>
              </p>
            </div>
          </div>
        `;
        } else {
          return `
          <div id="iw-container">
            <div class="iw-image">
              <div class="v-image v-responsive theme--light" style="max-height: 100px; width: 100%;">
                <div class="v-responsive__sizer" style="padding-bottom: 100%;"></div>
                <div class="v-image__image v-image__image--cover" style="background-image: url(&quot;${
                  marker.content.unitImage
                }&quot;); background-position: center center;"></div>
                <div class="v-responsive__content" style="width: 300px;"></div>
              </div>
            </div>
            <div class="iw-content">
              <div class="iw-subTitle">
                <a href="/wilayah/${marker.content.unitId}" target="_blank">
                  ${marker.content.unitName}
                </a>
              </div>
              <p>
                Jumlah Personil ${marker.content.personil * 1}
              </p>
            </div>
          </div>
        `;
        }
      }
    }
  }
};
</script>
<style lang="scss">
$mobile: 600px; // Screen min
$desktop: 1200px; // Screen max
$font-min: 16px;
$font-max: 20px;
$screen-diff: ($desktop / 1px - $mobile / 1px);
$font-diff: ($font-max / 1px - $font-min / 1px);
#iw-container {
  max-height: 400px;
}
.gm-style-iw {
  width: auto !important;
}
.iw-event {
  width: 300px;
  max-width: 300px;
}
.iw-unit {
  width: 400px;
  max-width: 400px;
}
.iw-user {
  width: 300px;
  max-width: 300px;
}
.bottom-text {
  letter-spacing: 0.15em;
  font-size: 20px;
  color: #daf6ff;
  font-weight: bold;
}

.bottom-text {
  // Mobile
  @media (max-width: 599px) {
    font-size: $font-min;
  }

  // Everything in between mobile (600px) to desktop (1200px)
  @media (min-width: 600px) and (max-width: 1200px) {
    font-size: calc(
      #{$font-min} + (100vw - #{$mobile}) / #{$screen-diff} * #{$font-diff}
    );
  }
  // Desktop
  @media (min-width: 1201px) {
    font-size: $font-max;
  }
}
.marquee-text-text {
  padding-left: 95vw;
  min-height: 24px;
}
.clock {
  background: #010c14;
  text-shadow: 0 0 20px #250692, 0 0 20px rgba(10, 175, 230, 0);
}
.gmap .gm-bundled-control {
  top: 0;
  bottom: unset;
}
.vue-map-hidden {
  display: block;
}
.card-map {
  position: absolute;
  top: 60px;
  left: 10px;
}
.custom-fab.v-btn--fab.v-size--default.v-btn--absolute.v-btn--bottom {
  bottom: 60px;
}
.vue-notification-custom {
  padding: 15px;
  margin: 0 5px 5px;
  font-size: 12px;
  color: #fff;
  background: #44a4fc;
  border-left: 5px solid #187fe7;

  &.warn {
    background: #ffb648;
    border-left-color: #f48a06;
  }

  &.error {
    background: #e54d42;
    border-left-color: #b82e24;
  }

  &.success {
    background: #4caf50;
    border-left-color: #4caf50;
  }
}
</style>
